/* global axios */

import ApiClient from './ApiClient';

class NucleoWorkOrderRequestsAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  requestPath(transactionId) {
    return `${this.url}/${transactionId}/nucleo_work_order_requests`;
  }

  catalog(transactionId) {
    return axios.get(`${this.requestPath(transactionId)}/catalog`);
  }

  create(transactionId, payload, idempotencyKey) {
    return axios.post(
      this.requestPath(transactionId),
      { solicitacao: payload },
      { headers: { 'Idempotency-Key': idempotencyKey } }
    );
  }
}

export default new NucleoWorkOrderRequestsAPI();
